import {inject, injectable} from 'inversify';
import {CoreDI} from '@fantasmagames/core/src/di/CoreDI';
import {IEventManagerWithAsync} from '@fantasmagames/core/src/events/_interfaces/IEventManager';
import {ScreenEvents} from '@fantasmagames/core/src/screen/ScreenEvents';
import {Device} from '@fantasmagames/core/src/device/Device';

@injectable()
export class VisibilityManager {

	@inject(CoreDI.IEventManagerWithAsync)
	private _eventManager: IEventManagerWithAsync;

	@inject(CoreDI.Device)
	private _device: Device;

	private _onVisibleCallback: Function;
	private _onInvisibleCallback: Function;

	private _visible: boolean = true;

	constructor() {
		let hidden;
		let visibilityState;
		let visibilityChange;

		if ('hidden' in document) {
			hidden = 'hidden';
			visibilityChange = 'visibilitychange';
			visibilityState = 'visibilityState';
		} else if ('mozHidden' in document) {
			hidden = 'mozHidden';
			visibilityChange = 'mozvisibilitychange';
			visibilityState = 'mozVisibilityState';
		} else if ('msHidden' in document) {
			hidden = 'msHidden';
			visibilityChange = 'msvisibilitychange';
			visibilityState = 'msVisibilityState';
		} else if ('webkitHidden' in document) {
			hidden = 'webkitHidden';
			visibilityChange = 'webkitvisibilitychange';
			visibilityState = 'webkitVisibilityState';
		}

		window.onblur = this.onChange.bind(this);
		window.onfocus = this.onChange.bind(this);

		window.onpagehide = this.onChange.bind(this);
		window.onpageshow = this.onChange.bind(this);

		if (document.addEventListener && hidden) {
			document.addEventListener(visibilityChange, () => {
				if (document[visibilityState] === 'visible') {
					this._visible = true;

					this._eventManager.emit(ScreenEvents.BECAME_VISIBLE);
					this._onVisibleCallback && this._onVisibleCallback();
				} else if (document[visibilityState] === 'hidden') {
					this._visible = false;

					this._eventManager.emit(ScreenEvents.BECAME_INVISIBLE);
					this._onInvisibleCallback && this._onInvisibleCallback();
				}
			}, false);
		}
	}

	public onChange(event: Event): void {
		if (this._device.isMobile) {
			if (event.type === 'pagehide' || event.type === 'blur') {
				this._visible = false;
				this._onInvisibleCallback && this._onInvisibleCallback();
				this._eventManager.emit(ScreenEvents.BECAME_INVISIBLE);

			} else if (event.type === 'pageshow' || event.type === 'focus') {
				this._visible = true;

				this._eventManager.emit(ScreenEvents.BECAME_VISIBLE);
				this._onVisibleCallback && this._onVisibleCallback();
			}
		}
	}

	public get visible(): boolean {
		return this._visible;
	}

	public set onVisibleCallback(value: Function) {
		this._onVisibleCallback = value;
	}

	public set onInvisibleCallback(value: Function) {
		this._onInvisibleCallback = value;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/core/src/screen/VisibilityManager.ts